module.exports = (__webpack_require__("UAjq"))("Pyi9");